const mappings = {
  requested: {
    label: 'Solicitados',
    icon: 'far fa-fw fa-question-circle',
    sequence: 0,
  },
  correction: {
    label: 'Em correção',
    icon: 'fas fa-fw fa-edit',
    sequence: 10,
  },
  corrected: {
    label: 'Corrigidos',
    icon: 'fas fa-fw fa-edit',
    sequence: 12,
  },
  screening: {
    label: 'Em triagem',
    icon: 'fas fa-fw fa-stethoscope',
    sequence: 20,
  },
  forwarded: {
    label: 'Encaminhados',
    icon: 'fas fa-fw fa-share-square',
    sequence: 30,
  },
  caught: {
    label: 'Saídas',
    icon: 'fas fa-fw fa-hand-holding-medical',
    sequence: 35,
  },
  hospitalized: {
    label: 'Internados',
    icon: 'fas fa-fw fa-procedures',
    sequence: 40,
  },
  medicalRelease: {
    label: 'Alta médica',
    icon: 'fas fa-fw fa-notes-medical',
    sequence: 50,
  },
  pullout: {
    label: 'Retiradas',
    icon: 'fas fa-fw fa-ambulance',
    sequence: 60,
  },
  done: {
    label: 'Concluídos',
    icon: 'fas fa-fw fa-check',
    sequence: 70,
  },
  rejected: {
    label: 'Rejeitados',
    icon: 'fas fa-fw fa-thumbs-down',
    sequence: 90,
  },
  death: {
    label: 'Óbitos',
    icon: 'fas fa-fw fa-heart-broken',
    sequence: 95,
  },
  canceled: {
    label: 'Cancelados',
    icon: 'fas fa-fw fa-ban',
    sequence: 99,
  },
  all: {
    label: 'Total de atendimentos clínicos',
    icon: 'fas fa-fw fa-stethoscope',
    sequence: 999,
  },
}

export default (status) => mappings[status] || { label: status, sequence: 998 }
